import * as Yup from "yup";
import * as Schemas from "../../validationSchemas.js";

export function nameValidationScheme(messages) {
  return Schemas.simpleStringSchema("Name", messages, true);
}

export function descriptionValidationScheme(messages) {
  return Yup.string();
}
